import { render, staticRenderFns } from "./MessageComments.vue?vue&type=template&id=ef351b8e&"
import script from "./MessageComments.vue?vue&type=script&lang=js&"
export * from "./MessageComments.vue?vue&type=script&lang=js&"
import style0 from "./MessageComments.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports